<div class="layout-item">
  <div class="container-list container">
    <div class="header-layout">
      <img src="assets/merchant-landing-page/work-together-left-section.png" class="img-left">
      <div class="header-dec">
        <p class="note" i18n>Work with Us</p>
        <h1 i18n>How we work together</h1>
      </div>
      <img src="assets/merchant-landing-page/work-together-right-section.png" alt="Right Image" class="img-right">
    </div>

      <div *ngFor="let item of list">
        <app-how-it-works-item
          [number]= "item.number"
          [title]= "item.title"
          [subtitle]= "item.subtitle"
          [image]="item.image"
         [direction]= "item.direction">
      </app-how-it-works-item>
      </div>
  </div>
</div>
